import { TokenUtils } from "./index";

export const UserStatusUtils = {
  updateStatus: (updateUserStatus) => {
    const decodedToken = TokenUtils?.getDecoded();
    updateUserStatus(decodedToken?.Status ?? null);
  },
};
